
/**
 *  true -> true
 * false -> false
 */
function tit_for_tat(history) {
  const len = history.length;
  if (len === 0)
    return true;
  return history[len - 1][0];
}

/**
 *  true |  true -> true
 *  true | false -> true
 * false | false -> false
 * false |  true -> true
 */
function tit_for_two_tats(history) {
  const len = history.length;
  if (len < 2)
    return true;
  return !(!history[len - 1][0] && !history[len - 2][0]);
}

/**
 * 50% -> true
 * 50% -> false
 */
function fifty_fifty(history) {
  return Math.random() <= 0.5;
}

/**
 * 65% -> true
 * 35% -> false
 */
function sixty_forty(history) {
  return Math.random() <= 0.65;
}

/**
 * 35% -> false
 * 65% -> true
 */
function forty_sixty(history) {
  return Math.random() <= 0.35;
}

const BOTS = [
  {
    name: 'Tit for tat',
    choose: tit_for_tat,
  },{
    name: 'Tit for two tats',
    choose: tit_for_two_tats,
  },{
    name: 'Fifty fifty',
    choose: fifty_fifty,
  },{
    name: 'Sixty forty',
    choose: sixty_forty,
  },{
    name: 'Forty sixty',
    choose: forty_sixty,
  },
];

function getBot() {
  const index = Math.floor(Math.random() * BOTS.length);
  return BOTS[index];
}

export default getBot;
